import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import api from "../lib/api";
import { Shell } from "./ForgotPassword";
import PasswordField, { passwordChecks } from "../components/PasswordField";

export default function ResetPassword() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const inFlight = useRef(false);
  const confirmRef = useRef(null);
  const valid = Object.values(passwordChecks(pw)).every(Boolean) && pw === confirm;
  const [msg, setMsg] = useState(token ? "" : t("resetMissing"));
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (inFlight.current || !valid || !token) return;
    inFlight.current = true; setLoading(true); setMsg("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      nav("/login", { replace: true, state: { passwordReset: true } });
    }
    catch { setMsg(t("resetBad")); }
    finally { inFlight.current = false; setLoading(false); }
  };
  return (
    <Shell title={t("resetTitle")}>
      {token && <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <PasswordField data-testid="reset-password" autoComplete="new-password" enterKeyHint="next" placeholder={t("newPassword")} value={pw} onChange={(e) => setPw(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); confirmRef.current?.focus(); } }} required minLength={8} showRules lang={lang} />
        <PasswordField data-testid="reset-password-confirm" inputRef={confirmRef} autoComplete="new-password" enterKeyHint="go" placeholder={lang === "de" ? "Passwort wiederholen" : "Repeat password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} lang={lang} />
        <button data-testid="reset-submit" className="pc-btn pc-btn-primary w-full" disabled={loading || !token || !valid}>{loading ? "…" : t("resetCta")}</button>
      </form>}
      {msg && <p data-testid="reset-msg" role="alert" className="mt-4 text-sm" style={{ color: "#ff8080" }}>{msg}</p>}
      <button onClick={() => nav("/login")} className="mt-6 text-sm" style={{ color: "var(--pc-cyan)", background: "none", border: "none", cursor: "pointer" }}>{t("backToLogin")}</button>
    </Shell>
  );
}
